import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { Button, IconSpinner } from '../../../components';
import { commonDisciplines, QUALIFICATION_DOC } from '../../../marketplace-custom-config';
import { USER_QUALIFICATION } from '../config';
import { QUALIFICATION_ID } from '../NavigationBar';
import css from '../ProfileSettingsForm.css';
import sectionCss from './QualificationSection.css';
import LogoutOverlay from '../LogoutOverlay';
import ScoreBadge from '../../../components/ScoreBadge/ScoreBadge';

const QualificationSection = ({
    qualifications,
    certifications,
    renderEditPencilIcon,
    uploadDocumentsInProgress,
    userDocuments = {},
    isPublic,
    setModalParams,
    handleEditSection,
    isLoggedOut,
    displayName,
    setPreviewModalOpen,
    setPreviewDoc,
    switchUserRoleAction,
    pageParams,
    scoreData,
    scoreReqInProgress,
}) => {
    const noData = !qualifications || qualifications.length === 0;
    const showScoreData = scoreData && typeof scoreData.qualificationScore === 'number';

    const scoreComponent = showScoreData && (
        <ScoreBadge scoreData={{ total: scoreData.qualificationScore, maxScore: 100 }} />
    );

    const Heading = ({ children }) => (
        <h2 className={classNames(css.infoHeading, sectionCss.infoHeading)}>
            <span>Qualifikationen</span>
            {scoreComponent}
            {children}
        </h2>
    );

    if (isPublic && noData && !isLoggedOut) {
        return (
            <div className={css.infoBlock}>
                <Heading />
                <p className={css.noData}>
                    {displayName} hat noch keine Qualifikationen hinzugefügt.
                </p>
            </div>
        );
    }

    if (isPublic && noData) return null;

    if (uploadDocumentsInProgress) return <IconSpinner />;

    const logoutOverlayVisible = isLoggedOut || switchUserRoleAction;

    const classes = classNames({
        [css.infoBlock]: true,
        [css.noInfoBlock]: noData,
        [css.viewProfileRequestWrapper]: logoutOverlayVisible,
        [sectionCss.viewProfileRequestWrapper]: logoutOverlayVisible,
    });

    const entities = Object.entries(certifications || []);

    return (
        <div className={classes} id={QUALIFICATION_ID}>
            {scoreReqInProgress && <IconSpinner />}
            <Heading />
            {noData ? (
                <section className={`${sectionCss.placeholderWrapper} ${css.placeholderWrapper}`}>
                    <div>
                        <div className={`${sectionCss.placeholderItem} ${css.placeholderItem}`} />
                        <div className={`${sectionCss.placeholderItem} ${css.placeholderItem}`} />
                        <div className={`${sectionCss.placeholderItem} ${css.placeholderItem}`} />
                    </div>
                    <div>
                        <div className={`${sectionCss.placeholderItem} ${css.placeholderItem}`} />
                        <div className={`${sectionCss.placeholderItem} ${css.placeholderItem}`} />
                        <div className={`${sectionCss.placeholderItem} ${css.placeholderItem}`} />
                    </div>
                </section>
            ) : (
                <div className={sectionCss.qualificationSection}>
                    {entities.map(([qualification, certifications]) =>
                        Array.isArray(certifications)
                            ? certifications.map(certification => {
                                  const document =
                                      userDocuments[QUALIFICATION_DOC] &&
                                      userDocuments[QUALIFICATION_DOC].find(
                                          ({ discipline, certification: certificationMetadata }) =>
                                              discipline === qualification &&
                                              certificationMetadata === certification
                                      );

                                  const { label } = commonDisciplines.find(
                                      ({ id }) => id === qualification
                                  ) || { label: qualification };

                                  return (
                                      <div
                                          key={`${certification}-${qualification}`}
                                          className={sectionCss.qualificationItem}
                                      >
                                          <p
                                              className={classNames(css.infoHeading, {
                                                  [sectionCss.infoHeading]: Boolean(scoreData),
                                              })}
                                          >
                                              {label}{' '}
                                              <code
                                                  className={css.editBlock}
                                                  onClick={() =>
                                                      setModalParams({
                                                          qualification,
                                                          certification,
                                                      })
                                                  }
                                              >
                                                  {renderEditPencilIcon(
                                                      USER_QUALIFICATION,
                                                      css.white
                                                  )}
                                              </code>
                                          </p>
                                          {certification && <p>{certification}</p>}
                                          <p>
                                              {document ? (
                                                  <span
                                                      className={css.previewLink}
                                                      onClick={() => {
                                                          setPreviewModalOpen(true);
                                                          setPreviewDoc(document);
                                                      }}
                                                  >
                                                      <FormattedMessage id="ProfileSettingsForm.sectionDoc" />
                                                  </span>
                                              ) : (
                                                  <FormattedMessage id="ProfileSettingsForm.noQualificationDocuments" />
                                              )}
                                          </p>
                                      </div>
                                  );
                              })
                            : null
                    )}
                </div>
            )}
            {(!isPublic || noData) && (
                <footer>
                    <Button
                        type="button"
                        onClick={() => {
                            handleEditSection(USER_QUALIFICATION);
                            setModalParams({});
                        }}
                        className={`${css.actionItem} ${css.actionBtn}`}
                    >
                        <FormattedMessage id="ProfileSettingsForm.addQualificationAction" />
                    </Button>
                </footer>
            )}
            <LogoutOverlay
                userName={displayName}
                isLoggedOut={isLoggedOut}
                rootClassName={sectionCss.viewProfileRequestAction}
                sectionName={USER_QUALIFICATION}
                switchUserRoleAction={switchUserRoleAction}
                pageParams={pageParams}
            />
        </div>
    );
};

export default QualificationSection;
